import { PlatformControllerFlowAPI } from '@wix/yoshi-flow-editor';
import {
  fetchConnectedUserData,
  generateTemplate,
  addEventListeners,
  selectorFactory,
  setStorage,
  setViewerEssentials,
  overrideWithMobileProps,
  ERROR_CODES,
  ERRORS_MESSAGE,
  setProGalleryLayouts,
  setProGalleryClickAction,
} from '../../utils/Viewer';
import { bi } from '../../bi';
import { WidgetPropsI, LightboxDataType } from '../../types';
import { ElementRoles, LayoutFeed, PresetNames } from '../../enums';

let lightboxData: LightboxDataType = {};

export const onPageReady = async (
  $w,
  flowAPI: PlatformControllerFlowAPI,
  $widget,
) => {
  const { t } = flowAPI.translations;
  const { populateMedia, collapseApp, generateErrorState, initiateElements } =
    selectorFactory($w, flowAPI);
  const { isViewer, isPreview, isMobile } = flowAPI.environment;
  const {
    preset,
    mobilePreset,
    isNewLayout,
    layoutSelected,
    layoutSelected_m,
  } = $widget.props;
  const isGrid = isNewLayout
    ? isMobile
      ? layoutSelected_m === LayoutFeed.Grid
      : layoutSelected === LayoutFeed.Grid
    : (preset === PresetNames.Grid2x3 && !isMobile) ||
      (mobilePreset === PresetNames.Grid2x3_M && isMobile);

  const mergedProps = { ...$widget.props };
  const props = overrideWithMobileProps(mergedProps, isMobile, isGrid);
  const isViewMode = isViewer || isPreview;
  bi({ flowAPI }).appLoadedStart();
  initiateElements(props);

  try {
    if ($w(`#${ElementRoles.LoadMore}`).label === '') {
      $w(`#${ElementRoles.LoadMore}`).label = t(
        'instagram-blocks.widget.demo.loadMoreBtn',
      );
    }
    setViewerEssentials(flowAPI);
    const { accountId } = props as WidgetPropsI;
    if (!isViewMode) {
      setStorage(flowAPI, props);
    }

    if (props.isNewLayout) {
      setProGalleryLayouts(props, $w, isMobile);
    } else {
      setProGalleryClickAction(props, $w);
    }

    if (accountId) {
      const { igUser, addedMedias, initialLightboxData } =
        await fetchConnectedUserData(flowAPI, props);
      const { instagramAccount } = igUser;
      const { synchronized } = instagramAccount || {};
      if (!synchronized && !isViewMode) {
        const errorData = {
          message: 'passwordChange',
        };
        generateErrorState(errorData, t, isGrid);
      } else {
        lightboxData = {
          ...lightboxData,
          [igUser.instagramAccount?.id as string]: initialLightboxData,
        };
        populateMedia({ igMedia: addedMedias, igUser, props });
        bi({ flowAPI }).appLoadedEnd(false);
      }
    } else {
      const { templateMedias, templateMediasWithDimensions, templateUser } =
        await generateTemplate(flowAPI, props);
      lightboxData = {
        user: templateUser,
        media: templateMedias,
      };
      populateMedia({
        igMedia: templateMediasWithDimensions,
        igUser: templateUser,
        props,
      });

      bi({ flowAPI }).appLoadedEnd(true);
    }

    if (isViewMode) {
      addEventListeners(flowAPI, $w, props, lightboxData);
    }
  } catch (error: any) {
    console.log('===>Collapsing App', { error });
    isViewMode ? collapseApp() : generateErrorState(error, t, isGrid);
  }
};
